import { z } from "zod";

import { requiredString } from "@/common/components/forms/schema";

const eagriAuthSchema = z.object({
  username: requiredString(),
  wsKey: requiredString(),
  szrid: requiredString(),
});

const eagriFarmSchema = z.object({
  farmName: requiredString(),
});

type EagriAuthFormValues = z.infer<typeof eagriAuthSchema>;
type EagriFarmFormValues = z.infer<typeof eagriFarmSchema>;

const EAGRI_AUTH_INITIAL_VALUES: EagriAuthFormValues = {
  username: "",
  wsKey: "",
  szrid: "",
};

export {
  eagriAuthSchema,
  eagriFarmSchema,
  EAGRI_AUTH_INITIAL_VALUES,
  type EagriAuthFormValues,
  type EagriFarmFormValues,
};
